import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Chip,
  Collapse,
  Select,
  MenuItem,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  IconButton,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { useState, useEffect } from "react";
import { get, post } from "../../../../utils/api";
import EmissionBulkAddForm from "./EmissionBulkAddForm";
import BulkFileUpload from "../../../Scope1/FugitiveEmmissions/BulkFileUpload";

const EmissionBulkAdd = ({
  matchData,
  setMatchData,
  onClose,
  onConfirm,
  bulkUploadTable,
  bulkuploadInputData,
  url,
  title1,
  title2,
  title3,
  keyValue1,
  keyValue2,
  keyValue3,
  options1,
  options2,
  options3,
  matched1,
  matched2,
  matched3,
  setFormDataBulkUpload,
  formDataBulkUpload,
  bulkUploadUrl,
  setsnackOpen,
}) => {
  const [expandedRows, setExpandedRows] = useState({});
  const [disabled, setDisabled] = useState(true);
  /** User's master-data dropdown picks — separate from uploaded excel row values. */
  const [masterSelections, setMasterSelections] = useState({});

  const [formData, setFormData] = useState([]);
  const [errors, setErrors] = useState({});

  // Document upload state management
  const [finalJson, setFinalJson] = useState(formDataBulkUpload);
  const [uploadValidationErrors, setUploadValidationErrors] = useState([]);
  const [hasValidationBeenAttempted, setHasValidationBeenAttempted] =
    useState(false);

  // Document upload confirmation state
  const [documentUploadConfirmed, setDocumentUploadConfirmed] = useState(false);
  // Document upload type state
  const [documentUploadType, setDocumentUploadType] = useState("none"); // "none", "individual", "same"
  const [commonDocument, setCommonDocument] = useState(null);
  const [individualDocuments, setIndividualDocuments] = useState({});
  // State to show confirmation dialog for proceeding without documents
  const [showNoDocumentDialog, setShowNoDocumentDialog] = useState(false);

  const inputData = [
    {
      fieldName: "vendorLegalName",
      title: "Vendor Legal Name",
      placeholder: "Enter Legal Name",
      type: "text",
      required: true,
      //   url: `${api}/vendor/getAll`, // Assuming there's an API to get all vendors
    },
    {
      fieldName: "country",
      title: "Country",
      placeholder: "Tap to Select",
      type: "select",
      required: true,
    },
    {
      fieldName: "goodsAndServicesName",
      title: "Name of Goods and Services",
      placeholder: "Enter Name",
      type: "text",
      required: true,
    },
    {
      fieldName: "gstNumber",
      title: "GST Number",
      placeholder: "Enter 15 digit GST Number",
      type: "text",
      required: true,
    },
    {
      fieldName: "address",
      title: "Address",
      placeholder: "Enter Address",
      type: "text",
      required: true,
    },
    {
      fieldName: "personInChargeName",
      title: "Name of Person in Charge",
      placeholder: "Enter Incharge Name",
      type: "text",
      required: true,
    },
    {
      fieldName: "contactNumber",
      title: "Contact Number",
      placeholder: "Enter Mobile No ",
      type: "text",
      required: true,
    },
    {
      fieldName: "email",
      title: "Email ID",
      placeholder: "Enter Email",
      type: "text",
      required: true,
    },
  ];

  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  // Monitor jsonBulkUpload changes
  // useEffect(() => {
  //   if (jsonBulkUpload && jsonBulkUpload.length > 0) {
  //     setFinalJson(jsonBulkUpload);
  //   }
  // }, [jsonBulkUpload]);

  const fetchData = async () => {
    try {
      const response = await get(`/master/purchasedGoods`);
      setData(response.data.data); // Update the user list
      console.log(response.data.data, "response.data.data");
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const getBulkRows = (bulkData) =>
    Array.isArray(bulkData) ? bulkData : Object.values(bulkData ?? {});

  const getBulkRow = (bulkData, index) =>
    Array.isArray(bulkData) ? bulkData[index] : bulkData?.[index];

  /** Master-data dropdown selection only — never read from uploaded excel columns. */
  const getMasterFieldSelection = (index, title) =>
    String(masterSelections?.[index]?.[title] ?? "").trim();

  const updateMasterSelection = (index, title, value) => {
    setMasterSelections((prev) => ({
      ...prev,
      [index]: {
        ...(prev[index] || {}),
        [title]: value,
      },
    }));
  };

  const isMasterField = (field) =>
    field === title1 || field === title2 || field === title3;

  const updateBulkUploadRow = (index, updater) => {
    setFormDataBulkUpload((prev) => {
      if (Array.isArray(prev)) {
        const next = [...prev];
        next[index] = updater(getBulkRow(prev, index) ?? {});
        return next;
      }
      return {
        ...prev,
        [index]: updater(prev?.[index] ?? {}),
      };
    });
  };

  useEffect(() => {
    if (!matchData?.length) {
      setDisabled(true);
      return;
    }

    const hasInvalidRow = matchData.some((item, index) => {
      if (!item?.[matched1]) {
        const selectedVendor = getMasterFieldSelection(index, title1);
        if (!selectedVendor || selectedVendor === "add_new") {
          return true;
        }
      }

      if (!item?.[matched2]) {
        const activity = getMasterFieldSelection(index, title2);
        if (!activity || !options2?.includes(activity)) {
          return true;
        }
      }

      if (!item?.[matched3]) {
        const category = getMasterFieldSelection(index, title3);
        if (!category || !options3?.includes(category)) {
          return true;
        }
      }

      return false;
    });

    setDisabled(hasInvalidRow);
  }, [
    matchData,
    masterSelections,
    title1,
    title2,
    title3,
    matched1,
    matched2,
    matched3,
    options2,
    options3,
  ]);

  useEffect(() => {
    if (!bulkUploadTable) {
      setMasterSelections({});
      return;
    }
    const rows = getBulkRows(formDataBulkUpload);
    if (rows.length > 0) {
      setFinalJson(rows);
    }
  }, [bulkUploadTable, formDataBulkUpload]);

  // Document upload handler functions
  const handleDocumentUploadConfirmation = (confirmed) => {
    setDocumentUploadConfirmed(confirmed);

    if (!confirmed) {
      // Reset document upload type to "none" if user chooses not to upload
      setDocumentUploadType("none");
    }

    // Clear validation errors when document upload confirmation changes
    setUploadValidationErrors([]);
    setHasValidationBeenAttempted(false);
  };

  const handleDocumentUploadTypeChange = (event) => {
    setDocumentUploadType(event.target.value);

    setCommonDocument(null);
    setIndividualDocuments({});

    // Clear validation errors when document upload type is selected
    setUploadValidationErrors([]);
    setHasValidationBeenAttempted(false);
  };

  const handleCommonDocumentChange = (files) => {
    setCommonDocument(files);

    // Update finalJson with common document for all entries
    if (finalJson && finalJson.length > 0) {
      const updated = finalJson.map((entry) => ({
        ...entry,
        "Document (optional)": files,
      }));
      setFinalJson(updated);
    }

    // Clear validation errors when documents are uploaded
    if (files && files.length > 0) {
      setUploadValidationErrors([]);
      setHasValidationBeenAttempted(false);
    }
  };

  const handleIndividualDocumentChange = (index, files) => {
    setIndividualDocuments((prev) => ({
      ...prev,
      [index]: files,
    }));

    // Update finalJson with individual document for specific entry
    if (finalJson && finalJson.length > 0) {
      const updated = finalJson.map((entry, i) => {
        if (i === index) {
          return {
            ...entry,
            "Document (optional)": files,
          };
        }
        return entry;
      });
      setFinalJson(updated);
    }

    // Clear validation errors when documents are uploaded
    if (files && files.length > 0) {
      setUploadValidationErrors([]);
      setHasValidationBeenAttempted(false);
    }
  };

  const handleClearCommonDocument = () => {
    setCommonDocument(null);

    // Update finalJson to clear common document for all entries
    if (finalJson && finalJson.length > 0) {
      const updated = finalJson.map((entry) => ({
        ...entry,
        "Document (optional)": null,
      }));
      setFinalJson(updated);
    }
  };

  const handleClearIndividualDocument = (index) => {
    setIndividualDocuments((prev) => {
      const newDocs = { ...prev };
      delete newDocs[index];
      return newDocs;
    });

    // Update finalJson to clear individual document for specific entry
    if (finalJson && finalJson.length > 0) {
      const updated = finalJson.map((entry, i) => {
        if (i === index) {
          return {
            ...entry,
            "Document (optional)": null,
          };
        }
        return entry;
      });
      setFinalJson(updated);
    }
  };

  const handleProceedWithoutDocuments = () => {
    setShowNoDocumentDialog(false);
    performUpload();
  };

  const handleCancelProceedWithoutDocuments = () => {
    setShowNoDocumentDialog(false);
  };

  const validateUploadData = () => {
    const validationErrors = [];

    // Check if user wants to upload documents but hasn't uploaded any
    if (documentUploadConfirmed && documentUploadType === "none") {
      validationErrors.push(
        "Please select a document upload type when document upload is confirmed.",
      );
    }

    // Validate document upload requirements
    if (documentUploadConfirmed && documentUploadType !== "none") {
      const hasCommonDoc =
        documentUploadType === "same" &&
        commonDocument &&
        commonDocument.length > 0;
      const hasIndividualDocs =
        documentUploadType === "individual" &&
        Object.keys(individualDocuments).length > 0 &&
        Object.values(individualDocuments).some(
          (docs) => docs && docs.length > 0,
        );
      if (!hasCommonDoc && !hasIndividualDocs) {
        setShowNoDocumentDialog(true);
      }
    }
    return validationErrors;
  };

  const performUpload = async () => {
    const bulkRows = getBulkRows(formDataBulkUpload);
    const baseRows =
      finalJson && finalJson.length > 0 ? finalJson : bulkRows;
    const dataToUse = baseRows.map((row, index) => ({
      ...row,
      ...(masterSelections[index] || {}),
    }));

    // Prepare data structure for upload
    const uploadData = {
      excelData: dataToUse,
      documentUploadType: documentUploadType,
      commonDocument: commonDocument,
      individualDocuments: individualDocuments,
    };

    console.log("Final upload data structure:", uploadData);

    if (bulkUploadUrl) {
      await post(bulkUploadUrl, uploadData)
        .then((res) => {
          // Clear validation errors and reset validation attempted flag on successful upload
          setUploadValidationErrors([]);
          setHasValidationBeenAttempted(false);
          setsnackOpen({
            open: true,
            message: res.data.message,
            severity: "success",
          });
          onConfirm();
          onClose();
        })
        .catch((err) => {
          const errMessage = err.response?.data?.details
            ?.map((el) => el?.error)
            ?.join(",");
          if (err?.response?.status === 422) {
          }
          setsnackOpen({
            open: true,
            message:
              errMessage ?? err.response?.data?.message ?? "Network Error",
            severity: "error",
          });
        });
    } else {
      // Fallback to original onConfirm if no bulkUploadUrl provided
      onConfirm();
    }
  };

  const handleSubmit = async () => {
    // Mark that validation has been attempted
    setHasValidationBeenAttempted(true);

    const validationErrors = validateUploadData();
    console.log(validationErrors, "validationErrors");

    if (validationErrors.length > 0) {
      setUploadValidationErrors(validationErrors);
      return;
    }

    // Check if user wants to upload documents but hasn't uploaded any
    const needsDocs = documentUploadConfirmed && documentUploadType !== "none";

    if (needsDocs) {
      const hasCommonDoc =
        documentUploadType === "same" &&
        commonDocument &&
        commonDocument.length > 0;
      const hasIndividualDocs =
        documentUploadType === "individual" &&
        Object.keys(individualDocuments).length > 0 &&
        Object.values(individualDocuments).some(
          (docs) => docs && docs.length > 0,
        );

      if (!hasCommonDoc && !hasIndividualDocs) {
        setShowNoDocumentDialog(true);
        return;
      }
    }

    // If no dialog is needed, proceed with upload
    await performUpload();
  };

  if (!matchData || matchData.length === 0) {
    return null;
  }

  console.log(matchData, "matchData");
  // const handleFormChange = (index, field, value) => {
  //   setFormDataBulkUpload((prev) => ({
  //     ...prev,
  //     [index]: {
  //       ...prev[index],
  //       [field]: value,
  //     },
  //   }));
  //   console.log(formDataBulkUpload, "formDataBulkUpload");
  // };

  const handleFormChange = (index, field, value) => {
    if (isMasterField(field)) {
      updateMasterSelection(index, field, value);
    }

    if (field === title1 && value === "add_new") {
      setExpandedRows((prev) => ({
        ...prev,
        [index]: true,
      }));
      setFormData((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          vendorLegalName: matchData?.[index]?.[keyValue1] ?? matchData?.[index]?.vendor,
        },
      }));
      updateBulkUploadRow(index, (row) => ({
        ...row,
        [field]: value,
      }));
      return;
    }

    if (field === title1 && value !== "add_new" && value !== "") {
      setExpandedRows((prev) => ({
        ...prev,
        [index]: false,
      }));

      updateBulkUploadRow(index, (row) => ({
        ...row,
        [field]: value,
      }));

      setFinalJson((prev) => {
        const newArray = [...(prev || [])];
        newArray[index] = {
          ...(newArray[index] || {}),
          [field]: value,
        };
        return newArray;
      });
      setErrors((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          [field]: "",
        },
      }));
      return;
    }

    if (field !== title1) {
      updateBulkUploadRow(index, (row) => ({
        ...row,
        [field]: value,
      }));
      setFinalJson((prev) => {
        const newArray = [...(prev || [])];
        newArray[index] = {
          ...(newArray[index] || {}),
          [field]: value,
        };
        return newArray;
      });
    }
  };

  return (
    <>
      <Dialog
        open={bulkUploadTable}
        onClose={onClose}
        maxWidth="lg"
        sx={{
          "& .MuiDialog-paper": {
            width: "80%",
            margin: "16px",
            maxHeight: "calc(100% - 32px)",
            zIndex: 1000,
          },
        }}
      >
        <DialogTitle>Review Bulk Upload Data</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Review the matched and unmatched equipment data. Add unmatched items
            individually.
          </Typography>

          <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow sx={{ overflowX: "hidden" }}>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      width: title3 ? "15%" : title2 ? "25%" : "50%",
                    }}
                  >
                    Data Entered
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      width: title3 ? "15%" : title2 ? "25%" : "50%",
                    }}
                  ></TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      width: title3 ? "15%" : title2 ? "25%" : "50%",
                    }}
                  ></TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      width: title3 ? "15%" : title2 ? "25%" : "50%",
                    }}
                  >
                    Master Data
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      width: title3 ? "10%" : title2 ? "25%" : "50%",
                    }}
                  ></TableCell>
                </TableRow>
              </TableHead>
              <TableHead>
                <TableRow sx={{ overflowX: "hidden" }}>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      width: title3 ? "15%" : title2 ? "25%" : "50%",
                    }}
                  >
                    {title1 ? title1 : "Equipment Name"}
                  </TableCell>
                  {title2 && (
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        width: title3 ? "15%" : title2 ? "25%" : "50%",
                      }}
                    >
                      {title2 ? title2 : "Equipment Name"}
                    </TableCell>
                  )}
                  {title3 && (
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        width: title3 ? "15%" : title2 ? "25%" : "50%",
                      }}
                    >
                      {title3 ? title3 : "Equipment Name"}
                    </TableCell>
                  )}
                  {title1 && (
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        width: title3 ? "15%" : title2 ? "25%" : "40%",
                      }}
                    >
                      {title1 ? title1 : "Equipment Name"}
                    </TableCell>
                  )}
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      width: title3 ? "10%" : title2 ? "25%" : "40%",
                    }}
                  >
                    Action
                  </TableCell>
                  {title2 && (
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        width: title3 ? "15%" : title2 ? "25%" : "50%",
                      }}
                    >
                      {title2 ? title2 : "Equipment Name"}
                    </TableCell>
                  )}
                  {title3 && (
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        width: title3 ? "17.5%" : title2 ? "25%" : "50%",
                      }}
                    >
                      {title3 ? title3 : "Equipment Name"}
                    </TableCell>
                  )}
                  {documentUploadConfirmed &&
                    documentUploadType === "individual" && (
                      <TableCell sx={{ fontWeight: "bold", width: "15%" }}>
                        Document
                      </TableCell>
                    )}
                </TableRow>
              </TableHead>
              <TableBody>
                {matchData.map((item, index) => (
                  <>
                    <TableRow key={index} sx={{ overflowX: "hidden" }}>
                      <TableCell>
                        {keyValue1 ? item?.[keyValue1] : item.equipment}
                      </TableCell>
                      {title2 && (
                        <TableCell>
                          {keyValue2 ? item?.[keyValue2] : item.equipment}
                        </TableCell>
                      )}
                      {title3 && (
                        <TableCell>
                          {keyValue3 ? item?.[keyValue3] : item.equipment}
                        </TableCell>
                      )}
                      <TableCell>
                        {item[matched1] ? (
                          <Chip label="Matched" color="success" size="small" />
                        ) : (
                          <FormControl
                            size="small"
                            sx={{
                              minWidth: title3
                                ? "5rem"
                                : title2
                                  ? "10.5rem"
                                  : "20rem",
                              maxWidth: title3
                                ? "5rem"
                                : title2
                                  ? "10rem"
                                  : "12rem",
                            }}
                          >
                            <Select
                              value={
                                getMasterFieldSelection(index, title1) || ""
                              }
                              onChange={(e) =>
                                handleFormChange(index, title1, e.target.value)
                              }
                              fullWidth
                              displayEmpty
                              disabled={item[matched1]}
                            >
                              <MenuItem value="" disabled>
                                <em>Tap to Select</em>
                              </MenuItem>
                              <MenuItem value="add_new">
                                {title1 === "Machinery Name"
                                  ? "Add New Machinery +"
                                  : title1 === "Vendor"
                                    ? "Add New Vendor +"
                                    : "Add New Equipment +"}
                              </MenuItem>
                              {data?.map((item, index) => {
                                return (
                                  <MenuItem value={item?.vendorLegalName}>
                                    {item?.vendorLegalName}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        )}
                      </TableCell>
                      <TableCell>
                        {!item[matched1] &&
                          (getMasterFieldSelection(index, title1) === "add_new" ||
                          expandedRows[index] ? (
                            <Button
                              variant="contained"
                              size="small"
                              onClick={() => {
                                setExpandedRows((prev) => ({
                                  ...prev,
                                  [index]: !prev[index],
                                }));
                              }}
                              sx={{ minWidth: "60px" }}
                            >
                              {expandedRows[index] ? "Close" : "Open"}
                            </Button>
                          ) : null)}
                      </TableCell>

                      {title2 && (
                        <TableCell>
                          {item[matched2] ? (
                            <Chip
                              label="Matched"
                              color="success"
                              size="small"
                            />
                          ) : (
                            <FormControl
                              size="small"
                              sx={{ minWidth: "10.5rem", maxWidth: "10rem" }}
                            >
                              <Select
                                value={
                                  getMasterFieldSelection(index, title2) || ""
                                }
                                onChange={(e) =>
                                  handleFormChange(
                                    index,
                                    title2,
                                    e.target.value,
                                  )
                                }
                                fullWidth
                                displayEmpty
                                disabled={item[matched2]}
                              >
                                <MenuItem value="" disabled>
                                  Tap to Select
                                </MenuItem>
                                {options2 &&
                                  options2.map((item, index) => {
                                    return (
                                      <MenuItem value={item}>{item}</MenuItem>
                                    );
                                  })}
                              </Select>
                            </FormControl>
                          )}
                        </TableCell>
                      )}

                      {title3 && (
                        <TableCell>
                          {item[matched3] ? (
                            <Chip
                              label="Matched"
                              color="success"
                              size="small"
                            />
                          ) : (
                            <FormControl
                              size="small"
                              sx={{ minWidth: "6.5rem", maxWidth: "6.5rem" }}
                            >
                              <Select
                                value={
                                  getMasterFieldSelection(index, title3) || ""
                                }
                                onChange={(e) =>
                                  handleFormChange(
                                    index,
                                    title3,
                                    e.target.value,
                                  )
                                }
                                displayEmpty
                                disabled={item[matched3]}
                                sx={{ minWidth: "6.5rem", maxWidth: "6.5rem" }}
                                MenuProps={{
                                  PaperProps: {
                                    style: {
                                      width: "10.5rem",
                                    },
                                  },
                                }}
                              >
                                <MenuItem value="" disabled>
                                  Tap to Select
                                </MenuItem>
                                {options3 &&
                                  options3.map((item, index) => (
                                    <MenuItem
                                      key={index}
                                      value={item}
                                      sx={{
                                        whiteSpace: "normal",
                                        wordBreak: "break-word",
                                        maxWidth: "100%",
                                      }}
                                    >
                                      {item}
                                    </MenuItem>
                                  ))}
                              </Select>
                            </FormControl>
                          )}
                        </TableCell>
                      )}
                      {documentUploadConfirmed &&
                        documentUploadType === "individual" && (
                          <TableCell>
                            <BulkFileUpload
                              filesList={individualDocuments[index] || []}
                              handleChange={handleIndividualDocumentChange}
                              handleClear={handleClearIndividualDocument}
                              index={index}
                            />
                          </TableCell>
                        )}
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{ paddingBottom: 0, paddingTop: 0 }}
                        colSpan={7}
                      >
                        <Collapse
                          in={expandedRows[index]}
                          timeout="auto"
                          unmountOnExit
                        >
                          <EmissionBulkAddForm
                            index={index}
                            inputData={inputData}
                            formData={formData}
                            errors={errors[index]}
                            setErrors={setErrors}
                            setFormData={setFormData}
                            setExpandedRows={setExpandedRows}
                            equipment={item.equipment}
                            url={url}
                            value={item?.[keyValue1]}
                            matchData={matchData}
                            setMatchData={setMatchData}
                            bulkuploadInputData={inputData}
                            data={data}
                            submitUrl={`/master/purchasedGoods`}
                            matched={[matched1]}
                            setsnackOpen={setsnackOpen}
                            onAddItem={(itemData, rowIndex) => {
                              const vendorName = itemData?.vendorLegalName ?? "";
                              updateMasterSelection(rowIndex, title1, vendorName);
                              updateBulkUploadRow(rowIndex, (row) => ({
                                ...row,
                                [title1]: vendorName,
                              }));
                              setFinalJson((prev) => {
                                const newArray = [...(prev || [])];
                                newArray[rowIndex] = {
                                  ...(newArray[rowIndex] || {}),
                                  [title1]: vendorName,
                                };
                                return newArray;
                              });
                              setExpandedRows((prev) => ({
                                ...prev,
                                [rowIndex]: false,
                              }));
                              fetchData();
                            }}
                          />
                        </Collapse>
                      </TableCell>
                    </TableRow>
                    {/* Expandable form row */}
                  </>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Document Upload Section */}
          <Box
            sx={{ mt: 3, p: 2, border: "1px solid #e0e0e0", borderRadius: 1 }}
          >
            <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
              Document Upload
            </Typography>
            <Box>
              <FormControl component="fieldset">
                <FormLabel component="legend">
                  Do you want to upload document?
                </FormLabel>
                <RadioGroup
                  value={documentUploadConfirmed ? "yes" : "no"}
                  onChange={(e) =>
                    handleDocumentUploadConfirmation(e.target.value === "yes")
                  }
                  row
                >
                  <FormControlLabel
                    value="yes"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
            </Box>
            {documentUploadConfirmed && (
              <FormControl component="fieldset" sx={{ mb: 2, mt: 2 }}>
                <FormLabel component="legend">Document Upload Type</FormLabel>
                <RadioGroup
                  value={documentUploadType}
                  onChange={handleDocumentUploadTypeChange}
                  row
                >
                  <FormControlLabel
                    value="same"
                    control={<Radio />}
                    label="Same File for All Records"
                  />
                  <FormControlLabel
                    value="individual"
                    control={<Radio />}
                    label="Individual File for Each Record"
                  />
                </RadioGroup>
              </FormControl>
            )}

            {documentUploadConfirmed && documentUploadType === "same" && (
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  Upload a single document that will be associated with all
                  records:
                </Typography>
                <BulkFileUpload
                  filesList={commonDocument}
                  handleChange={handleCommonDocumentChange}
                  handleClear={handleClearCommonDocument}
                />
              </Box>
            )}

            {documentUploadConfirmed && documentUploadType === "individual" && (
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  Upload individual documents for each record. Documents will be
                  added as a new column in the table above.
                </Typography>
              </Box>
            )}
          </Box>

          {/* Validation Error Display - Only show after validation has been attempted */}
          {hasValidationBeenAttempted && uploadValidationErrors.length > 0 && (
            <Box
              sx={{
                mt: 2,
                p: 2,
                backgroundColor: "#ffebee",
                borderRadius: 1,
                border: "1px solid #f44336",
              }}
            >
              <Typography
                variant="h6"
                color="error"
                sx={{ mb: 1, fontWeight: "bold" }}
              >
                Error:
              </Typography>
              {uploadValidationErrors.map((error, index) => (
                <Typography
                  key={index}
                  variant="body2"
                  color="error"
                  sx={{ mb: 0.5 }}
                >
                  • {error}
                </Typography>
              ))}
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: "1rem" }}>
          <Button
            onClick={onClose}
            variant="outlined"
            color="primary"
            sx={{ marginRight: "1rem" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            color="primary"
            disabled={disabled}
          >
            Confirm Upload
          </Button>
        </DialogActions>
      </Dialog>
      {/* Confirmation Dialog for Proceeding Without Documents */}
      <Dialog
        open={showNoDocumentDialog}
        onClose={handleCancelProceedWithoutDocuments}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h6">No Documents Uploaded</Typography>
            <IconButton
              onClick={handleCancelProceedWithoutDocuments}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
            You have selected to upload documents but haven't uploaded any
            files.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Do you want to proceed without uploading documents?
          </Typography>
          <Typography variant="body2" color="text.secondary">
            You can still upload documents later if needed.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ padding: "1rem" }}>
          <Button
            onClick={handleCancelProceedWithoutDocuments}
            variant="outlined"
            color="primary"
            sx={{ marginRight: "1rem" }}
          >
            Upload Documents
          </Button>
          <Button
            onClick={handleProceedWithoutDocuments}
            variant="contained"
            color="primary"
          >
            Proceed Without Documents
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EmissionBulkAdd;
